export default "__VITE_ASSET__DA2Sswfh__"